import { Theme, Interpolation, css } from '@emotion/react'

export const tooltipTitle: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyFive};
  margin-bottom: 6px;
`

export const fullWidth = css`
  width: 100%;
`
